import React from 'react';
import paymobLogo from "./assets/paymob-logo.png";
function Footer() {
  return (
    <div className='footer-content'>
        <p>Powered by</p>
        <img src={paymobLogo} alt="" width="72px"/>
    </div>
  )
}

export default Footer